<div>
  <ng-template #template>{{message}}</ng-template>
  <kendo-toolbar [overflow]='true'>
    <kendo-toolbar-button [showText]="'always'" [showIcon]="'always'" [iconClass]="'ms-Icon ms-Icon--RawSource'" text="Show Mermaid Markdown" [toggleable]="true" [(selected)]="showDiagramText"></kendo-toolbar-button>
    <kendo-toolbar-button [showText]="'always'" [showIcon]="'always'" [iconClass]="'ms-Icon ms-Icon--RawSource'" text="Show Debug" [toggleable]="true" [(selected)]="debug"></kendo-toolbar-button>
    <kendo-toolbar-button [showText]="'always'" [showIcon]="'always'" [iconClass]="'ms-Icon ms-Icon--Copy'" text="Copy Mermaid Markdown" [toggleable]="true" [clipboard-copy]="this.diagramText" (copied)="copied(this.diagramText)"></kendo-toolbar-button>
    <kendo-toolbar-button [showText]="'always'" [showIcon]="'always'" [iconClass]="'ms-Icon ms-Icon--FileImage'" text="Export as PNG" (click)="onDownloadPNG($event)"></kendo-toolbar-button>
    <kendo-toolbar-button [showText]="'always'" [showIcon]="'always'" [iconClass]="'ms-Icon ms-Icon--FileImage'" text="Export as SVG" (click)="onDownloadSVG($event)"></kendo-toolbar-button>
    <subscription-button></subscription-button>
  </kendo-toolbar>

  @if (debug) {
    <code>
      <kendo-floatinglabel text="Definition:" style="width:100%">
        <textarea kendoTextArea style='width:100%; height:270px;' [(ngModel)]="def"></textarea>
      </kendo-floatinglabel>
      <button kendoButton (click)="this.generateMermaid(this.def)" style="top:-1px; margin-top: 18px;" [disabled]="!this.def">
        Re-Generate
      </button>
    </code>
  }
  @if (showDiagramText) {
    <pre>
      {{diagramText}}
    </pre>
  }

  <div id="output" class="mermaid">
  </div>
</div>
